import {
  CreditCard,
  CupSoda,
  ArrowRight,
  Check,
  MousePointerClick,
} from "lucide-react";

import { motion } from "framer-motion";

import "../styles/howitworks.css";

const steps = [
  {
    number: "01",
    icon: <MousePointerClick size={28} strokeWidth={1.5} />,
    title: "Choose",
    highlight: "Your Flavour",
    desc: "Browse the available protein drinks and choose the option that suits you.",
    points: [
      "Multiple flavours",
      "Simple selection",
      "Smart display",
    ],
  },
  {
    number: "02",
    icon: <CreditCard size={28} strokeWidth={1.5} />,
    title: "Make",
    highlight: "Your Payment",
    desc: "Complete your purchase using your preferred payment method.",
    points: [
      "Contactless payments",
      "Card payments",
      "Digital payments",
    ],
  },
  {
    number: "03",
    icon: <CupSoda size={28} strokeWidth={1.5} />,
    title: "Enjoy",
    highlight: "Your Drink",
    desc: "Collect your selected drink and get on with your day.",
    points: [
      "Convenient access",
      "Simple experience",
      "Made for active spaces",
    ],
  },
];

const HowItWorks = () => {
  return (
    <section id="works" className="journey">

      {/* Background elements */}

      <div className="journey-orb journey-orb-one" />
      <div className="journey-orb journey-orb-two" />

      {/* =========================================
          HEADER
      ========================================= */}

      <motion.div
        className="journey-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >

        <div className="journey-label">
          <span />
          HOW IT WORKS
          <span />
        </div>

        <h2>
          Simple by design.
          <br />
          <em>Smart by nature.</em>
        </h2>

        <p>
          Getting your protein shouldn't be complicated.
          Choose your drink, make your payment and enjoy.
        </p>

      </motion.div>


      {/* =========================================
          JOURNEY
      ========================================= */}

      <div className="journey-wrapper">

        {/* Connecting line */}

        <div className="journey-progress">
          <div className="journey-progress-line" />
          <div className="journey-progress-dot dot-one" />
          <div className="journey-progress-dot dot-two" />
          <div className="journey-progress-dot dot-three" />
        </div>


        {/* Steps */}

        <div className="journey-grid">

          {steps.map((step, index) => (

            <motion.div
              className="journey-card"
              key={step.number}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.6,
                delay: index * 0.15,
              }}
              viewport={{
                once: true,
                amount: 0.2,
              }}
            >

              {/* Card top */}

              <div className="journey-card-top">

                <span className="step-number">
                  {step.number}
                </span>

                <div className="step-icon">
                  {step.icon}
                </div>

              </div>


              {/* Content */}

              <div className="journey-card-content">

                <h3>
                  {step.title}
                  <br />
                  <em>{step.highlight}</em>
                </h3>

                <p>
                  {step.desc}
                </p>


                {/* Points */}

                <div className="step-points">

                  {step.points.map((point) => (

                    <div
                      className="step-point"
                      key={point}
                    >
                      <Check size={14} />
                      <span>{point}</span>
                    </div>

                  ))}

                </div>

              </div>


              {/* Arrow */}

              {index < steps.length - 1 && (
                <div className="journey-arrow">
                  <ArrowRight size={18} />
                </div>
              )}

            </motion.div>

          ))}

        </div>

      </div>


      {/* =========================================
          BOTTOM MESSAGE
      ========================================= */}

      <motion.div
        className="journey-bottom"
        initial={{
          opacity: 0,
          y: 25,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.6,
        }}
        viewport={{
          once: true,
        }}
      >

        <div className="journey-bottom-line" />

        <div className="journey-bottom-content">

          <span>
            DAGDA EXPERIENCE
          </span>

          <h3>
            Nutrition,
            <em> simplified.</em>
          </h3>

        </div>

        <div className="journey-bottom-line" />

      </motion.div>

    </section>
  );
};

export default HowItWorks;